// FILE: src/types/user.ts
// VERSION: Modified with full schema for ChefCoin Assistant Integration

// Define the possible user roles
export type UserRole = 'admin' | 'reader' | 'guest';

// Possible subscription tiers (must match the public.subscription_tier enum in the DB).
// The DB enum is: free | standard | premium | banned. 'free' is allowed even though
// no current users hold it; admin can set it through the Manage User dialog.
export type SubscriptionTier = 'free' | 'standard' | 'premium' | 'banned';

// Define the user access interface (remains unchanged)
export interface UserAccess {
  email: string;
  role: UserRole;
  dateCreated?: string;
}

// Enhanced user profile interface matching the database schema
// MODIFIED: This interface now completely matches the user_profiles table schema.
export interface UserProfile {
  id: string;
  email: string;
  role: UserRole;
  name: string | null; // Changed to allow null
  country: string | null; // Changed to allow null
  created_at: string;
  updated_at: string;
  subscription: SubscriptionTier;
  studio_uses_count: number;
  ai_tokens_used: number;
  last_active_at: string | null;
  chefcoins_balance: number;
  last_coin_reset_at: string | null;

}

// Common countries for the dropdown selector (remains unchanged)
export interface Country {
  code: string;
  name: string;
}

// Popular countries for quick selection (remains unchanged)
export const COUNTRIES: Country[] = [
  { code: 'US', name: 'United States' },
  { code: 'CA', name: 'Canada' },
  { code: 'GB', name: 'United Kingdom' },
  { code: 'DE', name: 'Germany' },
  { code: 'FR', name: 'France' },
  { code: 'IT', name: 'Italy' },
  { code: 'ES', name: 'Spain' },
  { code: 'NL', name: 'Netherlands' },
  { code: 'CH', name: 'Switzerland' },
  { code: 'AT', name: 'Austria' },
  { code: 'BE', 'name': 'Belgium' },
  { code: 'SE', name: 'Sweden' },
  { code: 'NO', name: 'Norway' },
  { code: 'DK', name: 'Denmark' },
  { code: 'AU', name: 'Australia' },
  { code: 'NZ', name: 'New Zealand' },
  { code: 'JP', name: 'Japan' },
  { code: 'KR', name: 'South Korea' },
  { code: 'SG', name: 'Singapore' },
  { code: 'IN', name: 'India' },
  { code: 'MX', name: 'Mexico' },
  { code: 'BR', name: 'Brazil' },
  { code: 'AR', name: 'Argentina' },
  { code: 'LK', name: 'Sri Lanka' },
];